import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {systemValues} from '../../app.constants';
import {InfluencerService} from '../../services/influencer/influencer.service';
import {InfluencerIgStoryLoadingStatus} from '../../../models/influencer';
import {Subscription} from 'rxjs/Subscription';
import {timer} from 'rxjs/observable/timer';
import {concatMap, filter, map, take} from 'rxjs/operators';
import {AchooPopupComponent} from '../achoo-popup/achoo-popup.component';
import {ModalService} from '../../services/modal/modal.service';

@Component({
  selector: 'achoo-user-avatar',
  templateUrl: './achoo-user-avatar.component.html',
  styleUrls: ['./achoo-user-avatar.component.scss']
})
export class AchooUserAvatarComponent implements OnInit, OnDestroy {

  @Input()
  public showCountryFlagIcon: boolean | false;

  @Input()
  public userAvatarPicture: string | null;

  @Input()
  public userCountryCode: string | null;

  @Input()
  public avatarWidth: number;

  @Input()
  public avatarHeight: number;

  @Input()
  public countryWidth: number;

  @Input()
  public countryHeight: number;

  @Input()
  public isTopCountryFlag: boolean | false;

  @Input()
  public showIgLoader: boolean | false;
  @Input()
  public influencerId: number;

  @Output()
  public afterImageLoaded: EventEmitter<any> = new EventEmitter<any>();

  public isLoadingImage = true;
  private _igStoryLoadingStatus: InfluencerIgStoryLoadingStatus;
  private igStoryLoadingSubscription: Subscription;

  constructor(private influencerService: InfluencerService) {
  }

  ngOnInit() {
    if (this.showIgLoader) {
      this.igStoryLoadingSubscription = this.influencerService.loadingNewStoriesEvent.subscribe(newStatus => {
        this._igStoryLoadingStatus = newStatus;
      });
    }
  }

  ngOnDestroy() {
    if (this.igStoryLoadingSubscription) {
      this.igStoryLoadingSubscription.unsubscribe();
    }
  }

  resolveNoAvatarUrl() {
    this.userAvatarPicture = systemValues.defaultUserAvatarPicture;
  }

  onLoadedImage() {
    this.isLoadingImage = false;
    this.afterImageLoaded.emit(true);
  }

  calculateTopPosition() {
    if (this.isTopCountryFlag) {
      return 0.3125;
    } else {
      return (this.avatarHeight - this.countryHeight) / 2 + 0.1;
    }
  }
  calculateLeftPosition() {
    if (this.isTopCountryFlag) {
      return this.avatarWidth - (this.countryWidth / 2) - 0.25;
    } else {
      return this.avatarWidth - (this.countryWidth / 2) + 0.25;
    }
  }

  get isLoadingNewStories() {
    return this._igStoryLoadingStatus && this._igStoryLoadingStatus === InfluencerIgStoryLoadingStatus.PROCESSING;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/achoo-user-avatar/achoo-user-avatar.component.ts